// Full-document render of the Oscar account-login view: PageSkeleton (the
// React document shell) wrapping the legacy account-page layout — the brand
// heading, the LoginStandalone form island, the decorative account image, and
// the customer-service info block. The headings + block copy arrive
// pre-localized as props (server-side gettext, matching the legacy
// {% trans %} path under whatever LANGUAGES the site configures).
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { CustomerServiceInfoBlock } from "../components/CustomerServiceInfoBlock";
import { PageSkeleton } from "../components/PageSkeleton";
import { Template as LoginStandalone } from "./LoginStandaloneTemplate";

export const Template = (
    props: templates.LoginDocumentTemplate,
): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <header>
                    <h1>{props.page_copy?.page_heading}</h1>
                </header>

                <section className="account-page-container">
                    <div>
                        <h2>{props.page_copy?.section_heading}</h2>
                        <LoginStandalone {...props.login_standalone} />
                    </div>
                    <div>
                        {/* Decorative image: empty alt attr */}
                        <img
                            src={`${staticURL}img/accounts/accounts-page-img.jpg`}
                            alt=""
                        />
                    </div>
                </section>
            </div>

            {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
        </PageSkeleton>
    );
};
